import React from "react";
import { Table } from "../../components";
import { useRequest } from "../../utils";
//locall

const sourceLabel = (source) => {
  switch (source) {
    case "home_free_course":
      return "دورهٔ رایگان (هوش خودرو)";
    case "smart_trader_free_course":
      return "ثبت‌نام دوره معامله‌گر هوشمند";
    default:
      return source || "—";
  }
};

const statusLabel = (status) => {
  switch (status) {
    case "new":
      return "جدید";
    case "contacted":
      return "پیگیری شده";
    case "converted":
      return "تبدیل شده";
    default:
      return status || "—";
  }
};

const formatDate = (value) => {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString("fa-IR");
  } catch (e) {
    return value;
  }
};

const GetLeads = (props) => {
  const [
    get_leads_error,
    get_leads_loading,
    get_leads_data,
    get_leads_function,
  ] = useRequest({
    method: "get",
    url: "/get_leads",
  });

  return (
    <>
      {/* <!-- BEGIN: Content--> */}
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">
                لیدهای فرم رایگان
              </h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">لیدها</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        {get_leads_loading ? <p>در حال بارگذاری...</p> : null}
        {get_leads_error ? (
          <p>لیدی ثبت نشده یا خطایی رخ داده است.</p>
        ) : null}
        {get_leads_data ? (
          <Table
            Thead={() => (
              <tr>
                <th className="table--title">ردیف</th>
                <th className="table--title">تلفن همراه</th>
                <th className="table--title">نام</th>
                <th className="table--title">ایمیل</th>
                <th className="table--title">شهر</th>
                <th className="table--title">منبع</th>
                <th className="table--title">دوره ثبت‌نام‌شده</th>
                <th className="table--title">وضعیت</th>
                <th className="table--title">دفعات ارسال</th>
                <th className="table--title">تاریخ ثبت</th>
              </tr>
            )}
            Tbody={() =>
              get_leads_data.data.map((item, index) => (
                <tr key={item._id}>
                  <td>{index + 1}</td>
                  <td>
                    {(item.country_code ? "+" + item.country_code + " " : "") +
                      "0" +
                      item.phone_number}
                  </td>
                  <td>{item.name || "—"}</td>
                  <td>{item.email || "—"}</td>
                  <td>{item.city || "—"}</td>
                  <td>{sourceLabel(item.source)}</td>
                  <td>{item.registered_product_title || "—"}</td>
                  <td>{statusLabel(item.status)}</td>
                  <td>{item.submit_count || 1}</td>
                  <td>{formatDate(item.creation_date)}</td>
                </tr>
              ))
            }
          />
        ) : null}
      </div>
      {/* <!-- END: Content--> */}
    </>
  );
};

export { GetLeads };
